<template>
    <div v-if="!loading && usage" class="rounded-xl border border-gray-100 bg-gray-50 p-3">
        <div class="mb-2 flex items-center justify-between">
            <span class="text-[10px] font-semibold uppercase tracking-wide text-gray-400">Limites do mês</span>
            <router-link :to="{ name: 'usageLimits' }" class="text-[10px] font-semibold text-cyan-600 hover:text-cyan-700">Ver detalhes</router-link>
        </div>
        <div class="space-y-2">
            <UsageMeter
                compact
                title="Relatórios IA"
                :used="usage.standard.used"
                :limit="usage.standard.limit"
                :extra-credits="usage.standard.extraCredits"
            />
            <UsageMeter
                compact
                title="Análises ACIA"
                :used="usage.acia.used"
                :limit="usage.acia.limit"
                :extra-credits="usage.acia.extraCredits"
            />
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { UsageService } from '@/services/Entity';
import UsageMeter from './UsageMeter.vue';

export default {
    name: 'SidebarUsage',
    components: { UsageMeter },
    setup() {
        const loading = ref(true);
        const usage = ref(null);

        onMounted(async () => {
            try {
                const { data } = await UsageService.getUsage();
                usage.value = (data && data.data) || null;
            } catch {
                usage.value = null;
            } finally {
                loading.value = false;
            }
        });

        return { loading, usage };
    }
};
</script>
